import React, {useEffect, useState} from 'react';
import {addModalListener, removeModalListener} from '../services';

export const Modals: React.FC = () => {
  const [modalStack, setModalStack] = useState<React.ReactElement<any, any>[]>(
    [],
  );

  // Listen to changes in the modal stack and rerender on change!
  useEffect(() => {
    const listenerId = addModalListener(modals =>
      setModalStack(
        modals.map(({modalId, Component, props}) => (
          <Component key={modalId} {...props} />
        )),
      ),
    );
    return () => removeModalListener(listenerId);
  }, []);

  return <React.Fragment>{modalStack}</React.Fragment>;
};
